import {
  ConfigurationSetting,
  ConfigurationSettingCodes,
} from '@maximizer/core/shared/domain';
import {
  CODE_3_FILTER_CONFIGURATION,
  CODE_4_FILTER_CONFIGURATION,
  DefaultDataProcessingFeatures,
  IQBoostSavedConfigurationUser,
  IQDataProcessingFeatures,
  parseIqBoostConfigurationRecord,
} from '@maximizer/ai/data-access';

export const DATA_PROCESSING_SETTING_CODES: ConfigurationSettingCodes = {
  code3: CODE_3_FILTER_CONFIGURATION,
  code4: CODE_4_FILTER_CONFIGURATION,
};

type AnonymizationFeatures = Pick<IQDataProcessingFeatures, 'anonymized'>;

export type DataProcessingRecord = Partial<
  Pick<IQBoostSavedConfigurationUser, 'dataProcessingFeatures' | 'dataScope'>
>;

export function parseDataProcessingRecord(
  textValue: string,
): DataProcessingRecord {
  return parseIqBoostConfigurationRecord<DataProcessingRecord>(
    textValue,
    () => ({ dataProcessingFeatures: { ...DefaultDataProcessingFeatures } }),
  );
}

function parseDataProcessingFeatures(
  setting: ConfigurationSetting | null | undefined,
): IQDataProcessingFeatures | null {
  if (!setting?.textValue) return null;
  return (
    parseDataProcessingRecord(setting.textValue).dataProcessingFeatures ?? null
  );
}

export function parseUserAnonymization(
  setting: ConfigurationSetting | null | undefined,
): boolean {
  return parseDataProcessingFeatures(setting)?.anonymized ?? false;
}

export function parseAdminAnonymizationFeatures(
  setting: ConfigurationSetting | null | undefined,
): AnonymizationFeatures | null {
  return parseDataProcessingFeatures(setting);
}

export function isAdminAnonymizationEnabled(
  adminFeatures: AnonymizationFeatures | null | undefined,
): boolean {
  return adminFeatures?.anonymized === true;
}

export function resolveAnonymizationEnabled(
  userSetting: ConfigurationSetting | null | undefined,
  adminFeatures: AnonymizationFeatures | null | undefined,
): boolean {
  return (
    isAdminAnonymizationEnabled(adminFeatures) ||
    parseUserAnonymization(userSetting)
  );
}

export function parseAdminDataProcessingFeatures(
  setting: ConfigurationSetting | null | undefined,
): IQDataProcessingFeatures | null {
  return parseDataProcessingFeatures(setting);
}
